import { render } from "./ManageTenant.vue?vue&type=template&id=567c003c"
import script from "./ManageTenant.vue?vue&type=script&lang=js"
export * from "./ManageTenant.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__